import fulfill from '../../../fulfill';
import { SideEffectFunction } from '../../../sideEffects';
import { CORE_API_HOSTNAME } from '../../../env';
import startOfMonth from 'date-fns/startOfMonth';
import isWithinInterval from 'date-fns/isWithinInterval';
import subMonths from 'date-fns/subMonths';
import { Receipt } from '../../../types/receipts';
import { Receipts } from '../../types';
import { ActionTypes, GetLastReceipts, FetchLastReceiptsResponse } from './actions';

const limitReceiptsToLast12Months = (receipts: Receipt[]) => {
    const end = new Date();
    const start = startOfMonth(subMonths(end, 11));
    const interval = { start, end };
    return receipts.filter((r: Receipt) => isWithinInterval(new Date(r.purchase_at), interval));
};


const RECEIPT_LIMIT = 100;
const fetchLastReceipts: SideEffectFunction<GetLastReceipts, FetchLastReceiptsResponse> = async action => {
    const { accountId, id } = action.payload;
    const result: FetchLastReceiptsResponse = await fulfill.get({
        accountId,
        url: `${CORE_API_HOSTNAME}/v1/accounts/${accountId}/receipts/customers/${id}?limit=${RECEIPT_LIMIT}`,
        handlers: {
            200: (receipts: Receipts) => ({
                type: ActionTypes.LastReceiptsResponse,
                payload: {
                    receipts: limitReceiptsToLast12Months(receipts.receipts),
                },
                meta: {
                    cause: action,
                },
            }),
            404: () => ({
                type: ActionTypes.LastReceiptsResponse,
                payload: {
                    receipts: [],
                },
                meta: {
                    cause: action,
                },
            }),
        },
    });
    return result;
};

const effects = {
    [ActionTypes.GetLastReceipts]: [fetchLastReceipts],
};

export default effects;
